import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}];
export function Footer() {
  return <footer className="bg-navy" data-id="element-69" data-mp="32pfc42m3b1ty">
      <div className="mx-auto max-w-2xl px-4 py-4 pb-20 text-center sm:pb-5" data-id="element-70" data-mp="36pfsvtwnvp46">
        <p className="text-xs text-white/85" data-id="element-71" data-mp="36nd57gize82m">© 2026 — Todos los Derechos Reservados.</p>
        <p className="mt-1 text-[0.68rem] leading-snug text-white/70" data-id="element-72" data-mp="3uftmhouw9w0v">
          {PRODUCT_NAME}™ es un producto educativo de apoyo. No sustituye formación docente o técnica, práctica
          supervisada, manuales de fabricantes, normativa eléctrica y de seguridad aplicable, licencias,
          certificaciones ni el criterio de un profesional habilitado. Las prácticas de electrónica pueden implicar
          riesgos cuando se realizan incorrectamente. Toda actividad debe adaptarse al nivel de los alumnos, realizarse
          con equipamiento adecuado y seguir las normas de seguridad correspondientes.
        </p>
        <p className="mt-1 text-xs text-white/85" data-id="element-73" data-mp="3lbdbmpwng3k8">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-energy underline-offset-2 transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-white hover:underline" data-id="element-74" data-mp="3gca7r8seo3du">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1" data-id="element-75" data-mp="81fq3xcm4u4q">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-white/85" data-id="element-76" data-mp="34gxjj8lkv8n">
            {links.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-77" data-mp="hs1wd0yfw8ar" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-78" data-mp="cu8u2j09byfr">•</span>}
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-energy" data-id="element-79" data-mp="qt8hjnc1a7ac">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}